export const helpers = {
    wait: (ms) => new Promise((resolve) => setTimeout(resolve, ms)),
    rand: () => {
        let str = '';
        for (let i = 0; i < 6; i++) {
            str += Math.floor(Math.random() * 10);
        }
        return Number(str);
    },
};
export const getUserId = () => window.utag_data?.accountId || '';
